// extracted by mini-css-extract-plugin
export default {"heading":"RefundPolicyPage_heading__J3Xow","contentHeading":"RefundPolicyPage_contentHeading__DQERU","content":"RefundPolicyPage_content__YHUmt"};